<template>
  <div id="about" class="about-wrap style7 ptb-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-right"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="about-img-wrap">
            <img
              src="../../assets/images/about/about-img-16.jpg"
              alt="Image"
              class="about-img-one"
            />
            <img
              src="../../assets/images/about/about-img-17.jpg"
              alt="Image"
              class="about-img-two"
            />
            <img
              src="../../assets/images/about/about-img-18.jpg"
              alt="Image"
              class="about-img-three"
            />
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="about-content">
            <div class="content-title style3">
              <span>About us</span>
              <h2>
                We Provide Special Care Through Our
                <span>Certified &amp; Experience</span> Doctors
              </h2>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
                The point of using amet has.
              </p>
            </div>
            <ul class="content-feature-list list-style style4">
              <li>
                <span><i class="ri-check-double-line"></i></span>Stop worrying,
                we will take care of your physical problems
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>Health
                insurance issues are the most important that Physician face
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>24/7 personal
                customer relationship manager
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>Lifetime
                warrenties on all treatment services
              </li>
            </ul>

            <div class="feature-item-wrap">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-laser-2"></i>
                </div>
                <div class="feature-text">
                  <h5>Latest Skin Care Products</h5>
                  <p>
                    It is a long established fact that reader will be distracted
                    by readable content sit amet consec tetur adiicing elit
                    facilis tempore.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>